<div class="footer-text-container" id="footer-text-container-main">
<span class="footer-text" id="footer-text-main">Remote Service Software</span>
</div>